module.exports = __webpack_public_path__ + "static/media/29DUNON2.0551c8eb.jpg";